import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { PRICING_FAQ } from "../content/pricing";
import { LANDING_FAQ_EXTRA, SUPPORT_TELEGRAM_LINK } from "../content/landing";

function renderAnswer(item) {
  if (item.supportLink) {
    return (
      <>
        По любым вопросам вы можете{" "}
        <a href={SUPPORT_TELEGRAM_LINK} target="_blank" rel="noopener noreferrer">
          написать в поддержку
        </a>
        . Специалисты отвечают с 9 до 20 часов по московскому времени.
      </>
    );
  }
  return item.answer;
}

const FAQ_ITEMS = [...PRICING_FAQ, ...LANDING_FAQ_EXTRA];

export default function AccordionComponent() {
  return (
    <div className="landing-faq-list">
      {FAQ_ITEMS.map((item) => (
        <Accordion key={item.question} disableGutters elevation={0}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`faq-${item.question}`}
          >
            {item.question}
          </AccordionSummary>
          <AccordionDetails>{renderAnswer(item)}</AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
}
